@if (variant === 'v2') {
<header class="public-header public-header--v2" role="banner">
  <div class="public-header--v2__bar">
    <div class="public-header--v2__inner">
      <a class="public-header--v2__logo" routerLink="/home" aria-label="Ir al inicio de neocrédito">
        <img src="assets/img/Home/svg/logo-neocredito-header.svg" alt="neocrédito" class="public-header--v2__logo-img"
          width="172" height="28" />
      </a>

      <div class="public-header--v2__actions">
        @if (showAuthButtons) {
        <a [routerLink]="loginRouterLink" class="public-header--v2__btn public-header--v2__btn--login"
          id="btn-header-iniciar-sesion" (click)="trackIniciarSesion()">
          Iniciar sesión
        </a>
        }
        @if (showRegisterButton) {
        <a routerLink="/home" fragment="home-crea-cuenta" class="public-header--v2__btn public-header--v2__btn--register"
          id="btn-header-registrate">
          Regístrate
        </a>
        }
        @if (showPartnerLogo && !showAuthButtons && !showRegisterButton) {
        <a
          class="public-header--v2__partner"
          href="https://www.bancoldex.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Sitio web Bancóldex"
        >
          <img
            class="public-header--v2__partner-img"
            src="assets/img/landing/logo-bancoldex-header.svg"
            alt="Bancóldex"
            width="144"
            height="26"
          />
        </a>
        }
      </div>
    </div>
  </div>
  <div class="public-header--v2__accent" aria-hidden="true">
    <span class="public-header--v2__accent-segment public-header--v2__accent-segment--1"></span>
    <span class="public-header--v2__accent-segment public-header--v2__accent-segment--2"></span>
    <span class="public-header--v2__accent-segment public-header--v2__accent-segment--3"></span>
  </div>
</header>
} @else {
<header class="public-header">
  <nav class="navbar navbar-expand-md sticky-top public-header__navbar">
    <div class="container-fluid justify-content-center justify-content-md-between">
      <div class="d-flex flex-row align-items-center">
        <a class="navbar-brand public-header__logo-wrap" routerLink="/home" aria-label="Ir al inicio">
          <img id="logo_neocredito" class="public-header__logo-neocredito img-fluid" src="assets/img/logo.svg"
            alt="Logo neocrédito" />
        </a>
        <a class="navbar-brand d-block d-md-none" href="https://www.bancoldex.com/" target="_blank"
          rel="noopener noreferrer" aria-label="Sitio web Bancoldex">
          <img class="public-header__logo-bancoldex img-fluid ms-md-5"
            src="assets/img/Home/svg/logo_bancoldex_morad.svg" alt="Logo Bancoldex" />
        </a>
      </div>
      <div class="d-flex flex-row align-items-center gap-2 gap-md-3" id="navbarRegistro">
        <a href="https://www.bancoldex.com/" target="_blank" rel="noopener noreferrer" class="d-none d-md-block"
          aria-label="Sitio web Bancoldex">
          <img class="public-header__logo-bancoldex img-fluid" src="assets/img/Home/svg/logo_bancoldex_morad.svg"
            alt="Logo Bancoldex - Promueve el desarrollo empresarial" />
        </a>
        @if (showAuthButtons) {
        <a [routerLink]="loginRouterLink" class="btn public-header__btn public-header__btn--outline hvr-shrink">
          Iniciar sesión
        </a>
        <a routerLink="/home" fragment="home-crea-cuenta" class="btn public-header__btn public-header__btn--primary hvr-shrink">
          Regístrate
        </a>
        }
      </div>
    </div>
  </nav>
</header>
}